const titleList: any[] = [
  {
    headTitle: "共済契約者番号:共済契約者名",
  },
  {
    headTitle: "申請・届出名",
  },
  {
    headTitle: "申請日時",
  },
  {
    headTitle: "状況",
  },
  {
    headTitle: "担当者名",
  },
  {
    headTitle: "新担当者名",
    dontNeedSort: true,
  },
];

const navigatePath = {
  "JOB-73": "/SCRW030001",
  "JOB-01": "/SCRW070001",
  "JOB-02": "/SCRW050001",
  "JOB-03": "/SCRW050003",
  "JOB-04": "/SCRW050002",
  "JOB-05": "/SCRW040001",
  "JOB-06": "/SCRW040001",
  "JOB-07": "/SCRW040002",
  "JOB-08": "/SCRW040002",
  "JOB-09": "/SCRW070007",
  "JOB-10": "/SCRW060101",
  "JOB-11": "/SCRW080003",
  "JOB-12": "/SCRW080004",
  "JOB-13": "/SCRW160011",
  "JOB-75": "/SCRC070105",
  "JOB-14": "/SCRW160007",
  "JOB-15": "/SCRW070003",
  "JOB-16": "/SCRW050009",
  "JOB-17": "/SCRW050004",
  "JOB-18": "/SCRW050008",
  "JOB-19": "/SCRW050004",
  "JOB-21": "/SCRW050006",
  "JOB-22": "/SCRW050007",
  "JOB-23": "/SCRC060108",
  "JOB-28": "/SCRW060003",
  "JOB-29": "/SCRW060003",
  "JOB-30": "/SCRW070011",
  "JOB-31": "/SCRW060004",
  "JOB-32": "/SCRW060004",
  "JOB-33": "/SCRW060005",
  "JOB-34": "/SCRC060132",
  "JOB-35": "/SCRW410001",
  "JOB-77": "/SCRW410001",
  "JOB-36": "/SCRW410002",
  "JOB-37": "/SCRW410030",
  "JOB-38": "/SCRW410030",
  "JOB-39": "/SCRW410006",
  "JOB-40": "/SCRW410004",
  "JOB-41": "/SCRW410005",
  "JOB-42": "/SCRW070004",
  "JOB-43": "/SCRW070004",
  "JOB-44": "/SCRW070012",
  "JOB-76": "/SCRC010004",
  "JOB-74": "/SCRW070010",
  "JOB-47": "/SCRW060102",
  "JOB-48": "/SCRW110007",
  "JOB-49": "/SCRW070005",
  "JOB-50": "/SCRW080005",
  "JOB-51": "/SCRW160004",
  "JOB-67": "/SCRW110006",
  "JOB-68": "/SCRW160009",
  "JOB-69": "/SCRW160002",
  "JOB-70": "/SCRW160002",
  "JOB-71": "/SCRW160002",
  "JOB-72": "/SCRW110006",
  "JOB-86": "/SCRW110006",
  "JOB-87": "/SCRW110006",
  "JOB-89": "/SCRW110006",
  "JOB-90": "/SCRW110006",
  "JOB-91": "/SCRW110006",
  "JOB-92": "/SCRW110006",
  "JOB-78": "/SCRW070010",
  "JOB-82": "/SCRW210002",
} as { [key: string]: string };

export { titleList, navigatePath };
